<template>
  <main>
    <section>
      <div class="align-content-center m-4" >
          <div class="page_title" style="display: flex;justify-content: center;">
              <div><h3 class="page_title"  style="display: inline-block;
                  height: 4.1rem;
                  border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Contact Us </h3></div>
          </div>
      </div>
      <div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">
        <div class="custom-header" style=" display: flex;text-align: center;">
          
        </div>
      </div>
  </section>
    <section>
      <div class="container " style="padding-top: 20px;">
        <section class="row content_padding text-left">
          
          <span>
            <p style="color: #FCB42E;font-size: 18px;">Overseas Sales Department：</p>
            <!-- <br> -->
            <p> Serving AF and OE Markets, OEM/ODM Projects and Brand Worldwide
            </p>
          </span>
          
        </section>

        <section class="people-padding pt-3">
          <div class="people-group">
            <div class="people-container">
              <img class="people-img" src="/assets/img/About/people1.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Ms. Ada</h5>
                <hr>
                <p class="card-text"> Email: sales5@sanmak.com </p>
                <p class="card-text"> skype:sanmak-ada </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/people2.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Ms. Jenny</h5>
                <hr>
                <p class="card-text"> Email:sales24@sanmak.com </p>
                <p class="card-text"> skype:sanmak-jenny </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/people3.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Ms. Sunny</h5>
                <hr>
                <p class="card-text"> Email:sales6@sanmak.com </p>
                <p class="card-text"> skype:sanmak-sunny </p>
              </div>
            </div>

            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/people4.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Ms.Corrine</h5>
                <hr>
                <p class="card-text"> Email:sales21@sanmak.com </p>
                <p class="card-text"> skype:sanmak-Corrine </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/people5.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Ms.Aggie</h5>
                <hr>
                <p class="card-text"> Email:sales20@sanmak.com </p>
                <p class="card-text"> skype:sanmak-aggie </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/people8.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Ms.Olivia</h5>
                <hr>
                <p class="card-text"> Email:sales3@sanmak.com </p>
                <p class="card-text"> skype:sanmak-Olivia </p>
              </div>
            </div>
          </div>



        </section>
<!-- 间隔行 -->
        <section class="content_padding text-left pt-3 ">
          <!-- <div class="row" style="height: 20px;background-color: #353535;"> </div>
          <p class="pt-4 pb-4">Overseas Sales Department：<br>
            Concentrate On Overseas Auto Accessories,OEM Project and Brand Clients;</p> -->
            <span>
              <p style="color: #FCB42E;font-size: 18px;">Domestic Sales Department:</p>
              <!-- <br> -->
              <p> Concentrate On Domestic Auto Accessories,OEM Project and Brand Clients
              </p>
            </span>
        </section>

        <section class="people-padding">
          <div class="people-group">
            <div class="people-container">
              <img class="people-img" src="/assets/img/About/people6.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Mr.Chen </h5>
                <p class="card-text">Chinese</p>
                <hr>
                <p class="card-text"> Email:2881252442@qq.com </p>
                <p class="card-text"> QQ: 2881252442 </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/people7.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Mr. Wen</h5>
                <p class="card-text">Chinese</p>
                <hr>
                <p class="card-text"> Email:2881252434@qq.com</p>
                <p class="card-text"> QQ: 2881252434 </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/MrHanwen.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Mr. Chen</h5>
                <p class="card-text">Market promotion</p>
                <hr>
                <p class="card-text"> Email:271277223@qq.com</p>
                <p class="card-text"> QQ: 271277223 </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/MrWan.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Mr. Wan</h5>
                <p class="card-text">Market promotion</p>
                <hr>
                <p class="card-text"> Email:237710883@qq.com</p>
                <p class="card-text"> QQ: 237710883 </p>
              </div>
            </div>
          </div>
        </section>
<!-- 间隔行/标题 -->
        <section class="content_padding text-left pt-3 ">
          <div class="row" style="height: 20px;background-color: #353535;"> </div>
          <!-- <p class="pt-4 pb-4">Thai factory management：<br> 
            Thailand factory production management and supply chain management；</p> -->
            <span>
              <p style="color: #FCB42E;font-size: 18px;">Thai factory management：</p>
              <!-- <br> -->
              <p>  Thailand factory production management and supply chain management；
              </p>
            </span>
        </section>
        <section class="people-padding">
          <div class="people-group">
            <div class="people-container">
              <img class="people-img" src="/assets/img/About/mrZhang.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Mr.Zhang </h5>
                <p class="card-text">Production management</p>
                <hr>
                <p class="card-text"> Email:2881252442@qq.com </p>
                <p class="card-text"> QQ: 2881252442 </p>
              </div>
            </div>
            <div class="people-container ">
              <img class="people-img" src="/assets/img/About/mrYang.png" alt="Card image cap">
              <div class="mark">
              </div>
              <div class="card-body">
                <h5>Mr. Yang</h5>
                <p class="card-text">Supply chain management</p>
                <hr>
                <p class="card-text"> Email:2881252434@qq.com</p>
                <p class="card-text"> QQ: 2881252434 </p>
              </div>
            </div>
            
          </div>
        </section>
      </div>
    </section>

  </main>
</template>

<script>
export default {
  name: 'Contact',

  data() {
    return {

    }
  },

  methods: {
  }
};
</script>

<style scoped>
@import '../../assets/css/main.css';

:deep(.people-padding) {
  display: flex;
  justify-content: center;
}

:deep(.people-group) {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  width: 53.5rem;
}

:deep(.people-container) {
  background-image: url('../../../public/assets/img/About/peopleBg.png');
  background-size: cover;
  background-repeat: no-repeat;
  text-align: left;
  position: relative;
  width: 13.75rem;
  height: 20rem;
  margin: 2rem 2rem;
  line-height: 1.8rem;
  cursor: pointer;
}

:deep(.people-container h5) {
  font-size: 18px;
}

:deep(.people-container p) {
  color: #B3B3B4;
  font-size: 14px;
}

:deep(.people-img) {
  max-height: 9.5rem;
}

:deep(.mark) {
  top: 10.5rem;
  position: absolute;
  width: 3px;
  height: 30px;
  background-color: #FCB42E;
}

:deep(hr) {
  margin: 0.8rem 0;
  color: #6D6E72;
  background-color: #6D6E72;
  height: 1px;
}
</style>
